import React from 'react'
import { injectIntl } from 'react-intl';

import Illustration from '../../assets/person-notebook.svg'
import DataQualificationIcon from '../../assets/products/accuracy.svg'
import BoletoIcon from '../../assets/products/barcode.svg'
// import PixIcon from '../../assets/products/pix.svg'
import BankTransferIcon from '../../assets/products/wallet.svg'
import * as S from './RegisterWizard.styled'

const Step1Introduction = ({ intl, ...props }) => {
  const products = [
    {
      identifier: 'bank-transfer',
      icon: <BankTransferIcon />,
      name: intl.messages.register.step1.products.banktransfer.title,
      description: Object.values(intl.messages.register.step1.products.banktransfer.description),
      features: Object.values(intl.messages.register.step1.products.banktransfer.features),
      description2: Object.values(intl.messages.register.step1.products.banktransfer.description2),
    },
    {
      identifier: 'data-qualification',
      icon: <DataQualificationIcon />,
      name: intl.messages.register.step1.products.dataqualification.title,
      description: Object.values(intl.messages.register.step1.products.dataqualification.description),
      features: Object.values(intl.messages.register.step1.products.dataqualification.features),
      description2: Object.values(intl.messages.register.step1.products.dataqualification.description2),
    },
    // {
    //   icon: <PixIcon />,
    //   name: intl.messages.register.step1.products.pix.title,
    //   subtitle: intl.messages.register.step1.products.pix.subtitle,
    //   description: Object.values(intl.messages.register.step1.products.pix.description),
    //   features: Object.values(intl.messages.register.step1.products.pix.features),
    //   description2: Object.values(intl.messages.register.step1.products.pix.description2),
    // },
    {
      identifier: 'boleto',
      icon: <BoletoIcon />,
      name: intl.messages.register.step1.products.boleto.title,
      description: Object.values(intl.messages.register.step1.products.boleto.description),
      features: Object.values(intl.messages.register.step1.products.boleto.features),
      description2: Object.values(intl.messages.register.step1.products.boleto.description2),
    },
  ]

  const handleNextStep = () => {
    props.nextStep()
    window.scrollTo(0,0)
  }

  return <>
    <S.Step1Header>
      <div className="header-content">
        <h1 dangerouslySetInnerHTML={{ __html: intl.messages.register.step1.title }}></h1>
        <div>
          {Object.values(intl.messages.register.step1.text1).map((text, key) => (
            <p key={key} dangerouslySetInnerHTML={{ __html: text }} />
          ))}
        </div>
      </div>
      <div className="header-illustration">
        <Illustration />
      </div>
    </S.Step1Header>
    <S.GridProducts>
      {products.map((product, key) => (
        <div key={key} className={`card-product border-card card-product--${product.identifier}`}>
          <div className="card-product__icon">{product.icon}</div>
          <div className="card-product__name">{product.name}</div>
          {product.subtitle && <div className="card-product__subtitle">{product.subtitle}</div>}
          <div className="card-product__description">
            {product.description.map((value, keyDescription) => (
              <p key={keyDescription} dangerouslySetInnerHTML={{ __html: value }} />
            ))}
          </div>
          <ul className="card-product__features">
            {product.features.map((value, keyFeature) => (
              <li key={keyFeature} dangerouslySetInnerHTML={{ __html: value }} />
            ))}
          </ul>
          <div className="card-product__description" style={{ marginBottom: 0, marginTop: 25 }}>
            {product.description2 && product.description2.map((value, keyDescription) => (
              <p key={keyDescription} dangerouslySetInnerHTML={{ __html: value }} />
            ))}
          </div>
        </div>
      ))}
    </S.GridProducts>

    <div style={{ marginBottom: 30 }} dangerouslySetInnerHTML={{ __html: intl.messages.register.step1.open_account_text }} />

    <div>
      <button 
        id="new-onboarding"
        className="button-next-wizard"
        onClick={() => handleNextStep()}>
        {intl.messages.register.step1.open_account}
      </button>
    </div>
  </>
}

export default injectIntl(Step1Introduction)